const module_name = "service.referral";

const $inject = ["$http", "PhpPolyfillObject"];

class ReferralService {
  /**
   * @param $http
   * @param {PhpPolyfillObject} PhpPolyfillObject
   */
  constructor($http, PhpPolyfillObject) {
    this.$http = $http;
    this.PhpPolyfillObject = PhpPolyfillObject;
  }

  no_data() {
    return {};
  }

  load_fax() {
    let handleSuccess = function (response) {
      return response.data.data;
    };

    let handleError = function (response) {
    };

    return this.$http
      .get("/admin/referral/fax/get")
      .then(handleSuccess, handleError);
  }

  save_fax(hmr, final, handleSuccess, handleError) {
    let referral_data = this.PhpPolyfillObject.fromObject(hmr.referral).intersectKey({
      patientTitle: true,
      patientFirstname: true,
      patientMiddlename: true,
      patientLastname: true,
      patientStreetAddress: true,
      patientCity: true,
      patientState: true,
      patientPostcode: true,
      patientDob: true,
      patientPhone: true,
      patientPhoneBusiness: true,
      patientMedicare: true,
      senderTitle: true,
      senderFirstname: true,
      senderMiddlename: true,
      senderLastname: true,
      senderIdentifiers: true,
    });

    return this.$http
      .post("/admin/referral/fax/update/" + hmr.id, {
        hmr: {
          clinic: hmr.clinic.id,
          gp: hmr.gp? hmr.gp.id: null,
          referral: referral_data,
          finalise: final,
          override_errors: hmr.override_errors,
        },
      })
      .then(handleSuccess, handleError);
  }

  max_id() {
    let handleSuccess = function (response) {
      return response.data.data;
    };

    let handleError = function (response) {
    };

    return this.$http
      .get("/admin/referral/all/get")
      .then(handleSuccess, handleError);
  }

  get_hmr(hmr_id) {
    let handleSuccess = function (response) {
      return response.data.data;
    };

    let handleError = function (response) {
    };

    return this.$http
      .get(`/admin/referral/data/${hmr_id}`)
      .then(handleSuccess, handleError);
  }

  look_up_geolocation(hmr, handleSuccess, handleError) {
    return this.$http
      .get(`/admin/referral/geolocation/${hmr.id}`)
      .then(handleSuccess, handleError);
  }

  save_hmr(hmr, handleSuccess, handleError) {
    let referral_data = this.PhpPolyfillObject.fromObject(hmr).intersectKey({
      status: true,
      assignedPharmacist: true,
      patientLatitude: true,
      patientLongitude: true,
    });

    referral_data.status = referral_data.status.id;

    if (referral_data.assignedPharmacist) {
      referral_data.assignedPharmacist = referral_data.assignedPharmacist.id;
    }

    if (referral_data.patientLatitude === "" && referral_data.patientLongitude === "") {
      referral_data.patientLatitude = null;
      referral_data.patientLongitude = null;
    }

    return this.$http
      .post(`/admin/referral/data/update/${hmr.id}`, {hmr: referral_data})
      .then(handleSuccess, handleError);
  }
}

ReferralService.$inject = $inject;

export default angular.module(module_name, [])
  .service("ReferralService", ReferralService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/referral.service.js
 **/